import { WorkSpaceState } from "./types";

export const workSpaceStateInit: WorkSpaceState = {
  error: null,
  data: null,
  item: null,
};

export default workSpaceStateInit;
